import useAdventureReviews from '../hooks/useAdventureReviews'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import styles from './AdventureReviews.module.scss'
import PropTypes from 'prop-types'
import AdventureReviews from './AdventureReviews'

export default function AdventureReviewsSection({ activityId }) {
  const { formatMessage } = useIntl()
  const { reviews } = useAdventureReviews(activityId)
  if(!reviews?.reviews?.length) {
    return null
  }

  return (
    <div className='wrapper trip-wrapper'>
      <h2 className='do-icon-title'>
        <img
          className={styles.headerIcon}
          src={`${window.staticPath}travel_dist/images/review-stars/star.svg`}
          alt={formatMessage(defineMessage({ defaultMessage: 'Star' }))}
        />
        <FormattedMessage defaultMessage='Reviews' />
      </h2>
      <AdventureReviews reviews={reviews} />
    </div>
  )
}

AdventureReviewsSection.propTypes = {
  activityId: PropTypes.number.isRequired,
}
